import React from "react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { criarProcessamentosDs } from "../../DataSources";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView } from "devextreme-react";
import api from "../../api-axios";
import notify from "devextreme/ui/notify";
import ShowError from "../../AppServices";

export default class ListarProcessamento extends React.Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.state = {
      popupErro: false,
      erro: "",
      filtroCorrente: [],
      filtro: {},
    };
    //this.history = useHistory();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.processamentosDs = criarProcessamentosDs();
    this.reprocessar = this.reprocessar.bind(this);
    this.verErro = this.verErro.bind(this);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    // let filtroCorrente = [["status", "=", 0], "or", ["status", "=", 1]];
    let filtroCorrente = [];

    if (filtro.dataInicial != undefined && filtro.dataInicial != "") {
      console.log("filtro log", filtro);
      var inicioCorrigido = new Date(filtro.dataInicial.setHours(0, 0, 0, 0));
      filtroCorrente.push(["data", ">=", inicioCorrigido]);
    }

    if (filtro.dataFinal != undefined && filtro.dataFinal != "") {
      console.log("filtro log", filtro);
      var fimCorrigido = new Date(filtro.dataFinal.setHours(23, 59, 59, 999));
      filtroCorrente.push(["data", "<=", fimCorrigido]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  componentDidMount() {
    this.filtrar();
  }

  acompanharProcesso(e) {
    this.props.history.push("/acompanharprocessamento/" + e.row.data.id);
  }

  reprocessar(e) {
    console.log("e reprocessar", e);
    api.post(`/receberarquivos/reenviar_arquivo_processamento/${e.row.data.id}`)
      .then(_ => {
        notify("Reprocessameento agendado com sucesso", "success");
      })
      .catch(error => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      })

  }

  verErro(e) {
    console.log("dados evento", e);
    this.setState({ popupErro: true, erro: e.row.data.msgErro ?? "" });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={2}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Data Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="dataFinal"
                editorType="dxDateBox"
                editorOptions={{ width: "100%", useMaskBehavior: true }}
                colSpan={1}
              >
                <Label text="Data Final" />
              </SimpleItem>
            </Form>
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <br />
          <h3>Processamentos</h3>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.processamentosDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            filterSyncEnabled={true}
          >
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "Acompanhar Processamento",
                  icon: "chevronnext",
                  onClick: (e) => this.acompanharProcesso(e),
                },
                {
                  hint: "Reprocessar",
                  icon: "redo",
                  onClick: (e) => this.reprocessar(e),
                },
                {
                  hint: "Detalhes do erro",
                  icon: "comment",
                  onClick: (e) => this.verErro(e),
                },
              ]}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              visible={false}
              allowEditing={false}
              width={80}
              alignment={"center"}
            />
            <Column
              dataField={"sequencial"}
              caption={"#"}
              allowEditing={false}
              width={120}
              alignment={"center"}
              sortIndex={1}
              sortOrder={"desc"}
            />

            <Column dataField={"data"} caption={"Data"} width={110} dataType={"date"} />

            <Column dataField={"tipoStr"} caption={"Tipo"} width={180} />
            <Column dataField={"statusStr"} caption={"Status"} width={180} />
            <Column dataField={"situacaoStr"} caption={"Situação"} width={120} />


            <Column dataField={"nome"} caption={"Nome"} />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
          <Popup
            visible={this.state.popupErro}
            onHiding={() => this.setState({ popupErro: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            title="Detalhe do Erro"
          >
            <ScrollView>
              {this.state.erro}
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "success",
                width: 150,
                onClick: () => {
                  this.setState({ popupErro: false })
                },
              }}
            />
          </Popup>
          <br />
        </div>
      </React.Fragment>
    );
  }
}
